import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { TruckDetailsComponent } from './truck-details.component';

const routes: Routes = [
  { path: '', component: TruckDetailsComponent, data: { title: 'Truck details' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TruckDetailsRoutingModule {}

@NgModule({
  imports: [
    TruckDetailsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [TruckDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TruckDetailsModule {}
